// Matches the API's one-line tagline limit (rules.MaxSubtitleLength).
export const MAX_TAGLINE_LENGTH = 60

// Counts code points, like the API; string length counts an emoji as two.
const characters = (value) => Array.from(value || '')

export const taglineLength = (value) => characters(value).length

// Like maxLength, but in code points: an edit that overflows keeps the
// existing text and trims only what was inserted.
export function limitTagline(previous, next) {
  const after = characters(next)
  if (after.length <= MAX_TAGLINE_LENGTH) return next
  const before = characters(previous)
  let start = 0
  while (start < before.length && start < after.length && before[start] === after[start]) start += 1
  let end = 0
  while (end < before.length - start && end < after.length - start && before[before.length - 1 - end] === after[after.length - 1 - end]) end += 1
  const room = Math.max(0, MAX_TAGLINE_LENGTH - start - end)
  return [...after.slice(0, start), ...after.slice(start, after.length - end).slice(0, room), ...after.slice(after.length - end)].join('')
}
